import { BookBookmark } from "@phosphor-icons/react";
import countDaysInMonth from "count-days-in-month";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import CardHistory from "./component/CardHistory";
import { ReactComponent as Gambar } from "./assets/svg/hello.svg";
import { ReactComponent as Gambarx } from "./assets/svg/menata.svg";

const Analysis = () => {
  const today = new Date();
  const [namaGweh, setNamaGweh] = useState(null);
  const [nemPendek, setnemPendek] = useState(null);

  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (
      !cookies.token ||
      cookies.token === null ||
      cookies.token === undefined
    ) {
      navigate("/login");
    } else {
      try {
        // Pastikan cookies.token adalah string dan valid
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const emailGweh = jwtDecode(token).email;
          const nemPendekGweh = jwtDecode(token).given_name;
          setNamaGweh(emailGweh);
          setnemPendek(nemPendekGweh);
        } else {
          navigate("/login");
          throw new Error("Invalid token format");
        }
      } catch (error) {
        console.log("MASUK SINI 3");

        navigate("/login");
        console.error("Invalid tokenmm", error);
      }
    }
  }, [cookies.token, navigate]); // Menambahkan dependencies

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (namaGweh !== null) {
      const response = fetch(
        `${process.env.REACT_APP_SERVER}/api/analysis/${namaGweh}`
      )
        .then((response) => response.json())
        .then((data) => setData(data))
        .catch((error) => setError(`An error occurred: ${error}`))
        .finally(() => setLoading(false));
    }
  }, [namaGweh]);

  const thisMonth = today.getMonth();
  const thisYear = today.getFullYear();
  const dayInMonthh = countDaysInMonth(thisYear, thisMonth);

  const componentTanggal = [];
  for (let s = 1; s < dayInMonthh + 1; s++) {
    const hariLiburrr = s % 7 === 0;

    const apaDiaAda = () => {
      if (loading) {
        return false;
      } else {
        const myData = data.payload;
        if (data.payload.datas.attendanceThisMonth !== undefined) {
          const isAttend = data.payload.datas.attendanceThisMonth.datas
            .filter((cb) => cb.is_acc === 1)
            .some((cb) => {
              const ambilHari = new Date(cb.check_in);
              const getDate = ambilHari.getDate();
              const check_is_valid = getDate === s && cb.kehadiran === "H";

              return check_is_valid;
            });
          if (isAttend) return "H";
          const isLeave = data.payload.datas.attendanceThisMonth.datas
            .filter((cb) => cb.is_acc === 1)
            .some((cb) => {
              const ambilHari = new Date(cb.check_in);
              const getDate = ambilHari.getDate();
              const check_is_valid = getDate === s && cb.kehadiran === "I";

              return check_is_valid;
            });
          if (isLeave) return "I";
          const isSick = data.payload.datas.attendanceThisMonth.datas
            .filter((cb) => cb.is_acc === 1)
            .some((cb) => {
              const ambilHari = new Date(cb.check_in);
              const getDate = ambilHari.getDate();
              const check_is_valid = getDate === s && cb.kehadiran === "S";

              return check_is_valid;
            });
          if (isSick) return "S";
          else return false;
        }
        return false;
      }
    };

    const beneranNih = apaDiaAda();

    componentTanggal.push(
      <div className="flex w-full justify-center items-center" key={s}>
        <div
          className={` flex justify-center items-center min-w-8 min-h-8  rounded-full text-xs ${
            loading
              ? "bg-slate-100 skeleton"
              : hariLiburrr
              ? "bg-slate-300 text-gray-500"
              : beneranNih === false
              ? "bg-slate-300 text-gray-500"
              : beneranNih === "H"
              ? "bg-green-600 text-white"
              : beneranNih === "I"
              ? "bg-blue-400 text-white"
              : beneranNih === "S"
              ? "bg-red-400 text-white"
              : "bg-slate-300 text-gray-500"
          }`}
        >
          <p className={loading ? "opacity-0" : ""}>{s}</p>
        </div>
      </div>
    );
  }

  if (loading)
    return (
      <div className="py-6 px-4 bg-gray-100 min-h-screen pb-28">
        {/* Section Greetings */}
        <section
          className={`
             bg-green-700 text-green-100 
            p-4 rounded-lg `}
        >
          <h2 className="text-xl font-semibold opacity-0">l</h2>
        </section>
        <section className="w-full shadow-xl p-6 bg-white rounded-2xl gap-4 grid grid-cols-7  my-6">
          <div className="font-semibold text-lg col-span-7 text-center pb-4 flex items-center justify-center">
            Attendance this month{" "}
            <span className="ml-2">
              <BookBookmark weight="bold" size={20} />
            </span>
          </div>
          {componentTanggal}
        </section>
        <div className=" flex flex-col gap-3">
          {/* Card */}
          <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
            <div className="px-6 py-2 justify-center items-center flex flex-col min-h-[5.25rem] skeleton min-w-[4.5rem] text-white  bg-gray-200 rounded-lg gap-3">
              <p className={"text-2xl font-bold opacity-0 "}>22</p>
              <p className="text-sm font-light opacity-0">22</p>
            </div>
            {/* BUILD TIME STATUS */}
            <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
              <div className="flex justify-evenly ">
                <div className="flex flex-col gap-0.5 items-center justify-center">
                  <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                    {/* {getIndochinaTime(cb.check_in)} */}
                  </p>
                  <p className="text-xs font-normal text-gray-400">Check In</p>
                </div>
                <div className="border-s border-gray-400 h-full"></div>
                <div className="flex flex-col gap-0.5 items-center justify-center ">
                  <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                    {/* {getIndochinaTime(cb.check_out)} */}
                  </p>
                  <p className="text-xs font-normal text-gray-400">Check Out</p>
                </div>
                <div className="border-s border-gray-400 h-full"></div>
                <div className="flex flex-col gap-0.5 items-center justify-center">
                  <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                    {/* {timeDifference(cb.check_in, cb.check_out)} */}
                  </p>
                  <p className="text-xs font-normal text-gray-400">
                    Total Hours
                  </p>
                </div>
              </div>
              <div className="flex  justify-center items-center">
                <div className="gap-1.5 w-64 skeleton h-4 bg-gray-100"></div>
              </div>
            </div>
          </div>

          <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
            <div className="px-6 py-2 justify-center items-center flex flex-col min-h-[5.25rem] skeleton min-w-[4.5rem] text-white  bg-gray-200 rounded-lg gap-3">
              <p className={"text-2xl font-bold opacity-0 "}>22</p>
              <p className="text-sm font-light opacity-0">22</p>
            </div>
            {/* BUILD TIME STATUS */}
            <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
              <div className="flex justify-evenly ">
                <div className="flex flex-col gap-0.5 items-center justify-center">
                  <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                    {/* {getIndochinaTime(cb.check_in)} */}
                  </p>
                  <p className="text-xs font-normal text-gray-400">Check In</p>
                </div>
                <div className="border-s border-gray-400 h-full"></div>
                <div className="flex flex-col gap-0.5 items-center justify-center ">
                  <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                    {/* {getIndochinaTime(cb.check_out)} */}
                  </p>
                  <p className="text-xs font-normal text-gray-400">Check Out</p>
                </div>
                <div className="border-s border-gray-400 h-full"></div>
                <div className="flex flex-col gap-0.5 items-center justify-center">
                  <p className="text-md font-semibold w-10 h-4 skeleton bg-gray-100 ">
                    {/* {timeDifference(cb.check_in, cb.check_out)} */}
                  </p>
                  <p className="text-xs font-normal text-gray-400">
                    Total Hours
                  </p>
                </div>
              </div>
              <div className="flex  justify-center items-center">
                <div className="gap-1.5 w-64 skeleton h-4 bg-gray-100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  else if (error) {
    <div>Error boy: ${error}</div>;
  }

  const dataRepublic =
    data.payload.datas.attendanceThisMonth === undefined
      ? []
      : data.payload.datas.attendanceThisMonth.datas.filter(
          (cb) => cb.is_acc === 1
        );

  return (
    <div className="py-6 px-4 bg-gray-100 min-h-screen pb-28">
      {/* Section Greetings */}
      <section
        className={` bg-green-700 text-green-100 
         p-4 rounded-lg `}
      >
        <h2 className="text-xl font-semibold">👋 Halo, {nemPendek}</h2>
      </section>
      <section className="w-full shadow-xl p-6 bg-white rounded-2xl gap-4 grid grid-cols-7  my-6">
        <div className="font-semibold text-lg col-span-7 text-center pb-4 flex items-center justify-center">
          Attendance this month{" "}
          <span className="ml-2">
            <BookBookmark weight="bold" size={20} />
          </span>
        </div>
        {componentTanggal}
      </section>
      <div className=" flex flex-col gap-3">
        {/* Card */}
        {dataRepublic.length !== 0 ? (
          <>
            {dataRepublic
              .filter((rb) => rb.kehadiran === "H")
              .map((cb, i) => {
                {
                  return <CardHistory cb={cb} key={i} />;
                }
              })}
          </>
        ) : (
          <>
            <div className="w-full h-32 flex items-center px-6 gap-2   justify-evenly shadow-lg rounded-xl bg-slate-50">
              <Gambar height={100} width={100} />
              <div className=" max-w-52">
                <p className="text-sm">
                  Hola!!!, <br />
                  Kamu belum absen nih pada bulan ini
                </p>
              </div>
            </div>
            <div className="w-full h-32 flex items-center px-6 gap-2  justify-evenly shadow-lg rounded-xl bg-slate-50">
              <div className=" max-w-52">
                <p className="text-sm">
                  Yuk dilengkapi agar kami bisa mendata, seluruh data kamu
                </p>
              </div>
              <Gambarx height={100} width={100} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Analysis;

const calculateWorkDays = (startDate, endDate) => {
  // Pastikan tanggal dalam format Date
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Pastikan startDate <= endDate
  if (start > end) {
    console.error("Start date must be earlier than or equal to the end date.");
    return 0;
  }

  let workDaysCount = 0;

  // Iterasi melalui setiap hari antara startDate dan endDate
  while (start <= end) {
    const day = start.getDay(); // 0 = Minggu, 1 = Senin, ..., 6 = Sabtu
    if (day !== 0 && day !== 6) {
      // Tambahkan ke hitungan jika bukan Sabtu atau Minggu
      workDaysCount++;
    }
    // Pindah ke hari berikutnya
    start.setDate(start.getDate() + 1);
  }

  return workDaysCount;
};
